export default "__VITE_ASSET__D5v_fDAK__"